import { Box } from "@mui/material"
import type { FC } from "react"

import { InvoiceComments } from "./InvoiceComments"
import { InvoiceDocuments } from "./InvoiceDocuments"
import { InvoiceVendorDetails } from "./InvoiceVendorDetails"

import type { Invoice } from "@/graphql/codegen/graphql"

interface InvoiceRowDetailsProps {
  invoice: Invoice
}

export const InvoiceRowDetails: FC<InvoiceRowDetailsProps> = ({ invoice }) => (
  <Box
    className='flex flex-col bg-primary-100 px-6'
    data-testid={`invoices.details-row.container-${invoice.invoiceId}`}
  >
    <InvoiceVendorDetails company={invoice.vendorCompany} accountingPeriod={invoice.accountingPeriod} />
    <Box className='flex gap-6'>
      <InvoiceComments invoiceId={invoice.invoiceId} />
      <InvoiceDocuments invoiceId={invoice.invoiceId} canDelete />
    </Box>
  </Box>
)
